import Swiper from 'swiper';

// ------------------------------------------------
//	スクロールアニメーション（.anim → .active）
//	fadeInUp / fadeIn 共通トリガー
// ------------------------------------------------
const funcAnim = () => {
	const items = document.querySelectorAll('.anim');
	if (!items.length) return;

	const check = () => {
		const th = window.innerHeight * 0.9;
		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (r.top < th && r.bottom > 0) el.classList.add('active');
		});
	};

	check();
	if (document.readyState !== 'complete') {
		window.addEventListener('load', check, { once: true });
	}
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// ------------------------------------------------
//	着回しコーデ swiper（各パンツのコーデ写真をカラー違いでスワイプ）
//	カード全体（写真＋カラー＋アイテム）を1スライドとして左右スワイプ。
//	※アコーディオン（3列CHECK）はJS不使用＝CSSのみ（アプリ版でも動く）
// ------------------------------------------------
const funcSlider = () => {
	const items = document.querySelectorAll('.pants__coord');
	if (!items.length) return;

	[...items].forEach((item) => {
		const el = item.querySelector('.swiper-container');
		if (!el) return;
		// スライドが1枚のみのカードはスワイプ不要（矢印も非表示はCSS側で対応可）
		const slides = el.querySelectorAll('.swiper-slide');
		new Swiper(el, {
			loop: slides.length > 1,
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 500,
			allowTouchMove: slides.length > 1,
			navigation: {
				prevEl: item.querySelector('.pants__coord-arrow--prev'),
				nextEl: item.querySelector('.pants__coord-arrow--next'),
			},
		});
	});
};

// ------------------------------------------------
//	スムーススクロール（.anchor）
// ------------------------------------------------
const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);

const funcSmoothScroll = () => {
	const duration = 500;
	document.querySelectorAll('.anchor').forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			const href = trigger.getAttribute('href');
			if (!href || !href.startsWith('#')) return;
			const target = document.getElementById(href.slice(1));
			if (!target) return;

			e.preventDefault();
			e.stopPropagation();

			const start = window.scrollY || 0;
			const dest = start + target.getBoundingClientRect().top;
			const dist = dest - start;
			const startTime = performance.now();

			const loop = (now) => {
				const nt = (now - startTime) / duration;
				if (nt < 1) {
					window.scrollTo(0, start + dist * easeInOut(nt));
					requestAnimationFrame(loop);
				} else {
					window.scrollTo(0, dest);
				}
			};
			requestAnimationFrame(loop);
		});
	});
};

// ------------------------------------------------
//	着回しコーデ タブ（ラジオ）
//	CSSの :checked ~ だけだと Chrome の style invalidation バグで
//	切替が反映されないケースを実測確認 → JSでインラインstyleを直接同期（Web版の保険）。
//	アプリ版(JSなし)はCSSの :checked ~ 機構がそのまま働く。
// ------------------------------------------------
const funcStyleTabs = () => {
	document.querySelectorAll('.pants__style').forEach((sec) => {
		const inputs = [...sec.querySelectorAll('input[type="radio"]')];
		const panels = [...sec.querySelectorAll('.pants__style-panel')];
		const btns = [...sec.querySelectorAll('.pants__tab-btn')];
		if (!inputs.length || !panels.length) return;

		const apply = () => {
			const i = inputs.findIndex((x) => x.checked);
			panels.forEach((p, k) => {
				p.style.visibility = k === i ? 'visible' : 'hidden';
				p.style.opacity = k === i ? '1' : '0';
			});
			btns.forEach((b, k) => {
				b.classList.toggle('is-open', k === i);
			});
		};
		// CHECKラベルのクリックを乗っ取る。labelのデフォルト動作（関連ラジオを activate＝
		// focus→scrollIntoViewでページがタブ画像の先頭まで飛ぶ）を preventDefault で止め、
		// checked はJSで直接立てて apply() でパネルだけ差し替える＝スクロール位置は一切動かさない。
		// ※アプリ版(JSなし)は label[for] → CSS :checked ~ のフォールバックがそのまま働く。
		btns.forEach((b, k) => {
			b.addEventListener('click', (e) => {
				e.preventDefault();
				inputs[k].checked = true;
				apply();
			});
		});
		apply();
	});
};

window.addEventListener('DOMContentLoaded', () => {
	funcAnim();
	funcSlider();
	funcSmoothScroll();
	funcStyleTabs();
});
